import { range } from 'lodash-es';
export const EXPIRATION_DAY_OPTIONS = range(1, 91);
